import type { CSSProperties, FunctionComponent } from 'react';

import { smallestPreviewBiggerThan } from '@trello/image-previews';
import type { PowerUpTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import type { BoardOption } from 'app/src/components/BoardSelector';

import styles from './BoardIcon.less';
interface TrelloBoardIconProps {
  boardOption?: BoardOption;
}

export const BoardIcon: FunctionComponent<TrelloBoardIconProps> = ({
  boardOption,
}) => {
  let backgroundColor, backgroundImageScaled;

  if (boardOption?.value.prefs) {
    backgroundColor = boardOption.value.prefs.backgroundColor;
    backgroundImageScaled = boardOption.value.prefs.backgroundImageScaled;
  }

  const backgroundStyle: CSSProperties = {};
  if (backgroundImageScaled) {
    const image = smallestPreviewBiggerThan(backgroundImageScaled, 96, 96);

    if (image) {
      backgroundStyle.backgroundImage = `url('${image.url}')`;
      backgroundStyle.backgroundSize = 'cover';
    }
  } else if (backgroundColor) {
    backgroundStyle.backgroundColor = backgroundColor;
  }

  return (
    <div
      className={styles.trelloBoardIcon}
      data-testid={getTestId<PowerUpTestIds>('board-icon')}
      style={backgroundStyle}
    />
  );
};
